import { css } from 'linaria';
import { styled } from 'linaria/react';
import { ElementType } from 'react';
import { whichBrowser } from 'utils/browsers';

export const wrapperStyles = css`
  position: relative;
  width: 100%;
  max-width: 1180px;
`;

export const Container: ElementType = styled.div<{ inScrollNow: boolean }>`
  display: flex;
  gap: var(--space-200);
  padding: var(--space-125) var(--space-150);
  overflow-x: scroll;
  scroll-snap-type: ${({ inScrollNow }) =>
    inScrollNow && whichBrowser() !== 'safari' ? 'none' : 'x proximity'};
  scroll-padding: var(--carousel-scroll-padding, 250px);
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (--from-desktop) {
    position: relative;
    left: -12px;
  }

  @media (--to-desktop) {
    width: 100vw;
    padding: 10px calc(-1 * var(--layout-ears));
    margin-left: var(--layout-ears);
    margin-right: var(--layout-ears);
    scroll-padding: auto;
    scroll-snap-type: none;

    &::after {
      margin-left: calc(-1 * var(--layout-ears));
    }
  }
`;

export const CarouselControl: ElementType = styled.div<{
  direction?: 'left' | 'right';
}>`
  position: absolute;
  top: 50%;
  left: ${({ direction }) => (direction === 'left' ? '0' : 'inherit')};
  right: ${({ direction }) => (direction === 'right' ? '18px' : 'inherit')};
  z-index: 2;
  margin-right: 0;
  transform: translateY(-50%) translateX(${({ direction }) => (direction === 'left' ? '-50%' : '50%')});
`;

export const controlStyles = css`
  box-shadow: var(--box-shadow-m);
`;

export const pageContentStyles = css`
  width: 100% !important;
  max-width: var(--fronton-layout-width);
  padding: 0 !important;
`;

export const carouselWrapperStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (--only-mobile) {
    padding: var(--space-150);
  }
`;

export const topLineStyles = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;

  @media (--only-mobile) {
    margin-bottom: 16px;
  }

  @media (--from-tablet) {
    margin-bottom: 14px;
  }
`;

export const titleStyle = css`
  color: var(--text-primary);
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal !important;
  font-weight: 600 !important;
`;
